import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MenuIcon from '@material-ui/icons/Menu'
import Button from 'components/CustomButtons/Button'
import pagesRoutes from 'routes/pages.jsx'
import { logout } from 'actions/auth'
import pagesHeaderStyle from 'assets/jss/material-dashboard-pro-react/components/pagesHeaderStyle.jsx'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class PagesHeader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      anchorEl: null
    }
  }

  handleDrawerToggle = () => {
    this.setState({ open: !this.state.open })
  }
  activeRoute(routeName) {
    if ('/' === this.props.location.pathname && '/' === routeName) {
      return true
    } else if ('/' !== routeName)
      return this.props.location.pathname.indexOf(routeName) > -1 ? true : false
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.setState({open: false})
    }
  }
  render() {
    let array_images = []
    let req = require.context(`../../assets/img/logo/`, false, /\.png$/)
    req.keys().forEach(function(key) {
      req(key);
      let name_image = key.slice(2)
      array_images.push({photos:require(`../../assets/img/logo/${name_image}`)})
    });

    const { classes, color, isAuthenticated, logout } = this.props

    const appBarClasses = cx({
      [' ' + classes[color]]: color
    })
    var list = (
        <List className={classes.list}>
          {pagesRoutes.map((prop, key) => {
            if (prop.noHeader || prop.redirect || (!isAuthenticated && prop.requireAuth) || (isAuthenticated && false === prop.requireAuth)) {
              return null
            }
            const navLink = classes.navLink + cx({ [' ' + classes.navLinkActive]: this.activeRoute(prop.path) })

            return (
                <ListItem key={key} className={classes.listItem}>
                  <NavLink to={prop.path} className={navLink}>

                    <ListItemText
                        primary={prop.short}
                        disableTypography={true}
                        className={classes.listItemText}
                    />
                  </NavLink>
                </ListItem>
            )
          })}
          {isAuthenticated &&
          <ListItem className={classes.listItem}>
            <Button onClick={() => logout()} className={classes.navLink} color='transparent'>

              <ListItemText
                  primary='Déconnexion'
                  disableTypography={true}
                  className={classes.listItemText}
              />
            </Button>
          </ListItem>}
        </List>
    )

    return (
        <AppBar position='static' className={classes.appBar + appBarClasses}>
          <ToastContainer/>
          <Toolbar className={classes.container}>
            <Hidden smDown implementation='css'>
              <div className={classes.flex}>
                {array_images.map((e, idx) =>
                    <Button component={NavLink} to='/' className={classes.title} color='transparent'>
                      <img src={e.photos} alt="Logo" className={classes.logo} />
                    </Button>
                )}
              </div>
            </Hidden>
            <Hidden mdUp>
              <div className={classes.flex}>
                {array_images.map((e, idx) =>
                    <Button component={NavLink} to='/' className={classes.title} color='transparent'>
                      <img src={e.photos} alt="Logo" className={classes.logo} />
                    </Button>
                )}
              </div>
            </Hidden>
            <Hidden smDown implementation='css'>
              {list}
            </Hidden>
            <Hidden mdUp>
              <Button
                  className={classes.sidebarButton}
                  color='transparent'
                  justIcon
                  aria-label='open drawer'
                  onClick={this.handleDrawerToggle}
              >
                <MenuIcon />
              </Button>
            </Hidden>
            <Hidden mdUp implementation='css'>
              <Hidden mdUp>
                <Drawer
                    variant='temporary'
                    anchor={'right'}
                    open={this.state.open}
                    classes={{
                      paper: classes.drawerPaper
                    }}
                    onClose={this.handleDrawerToggle}
                    ModalProps={{
                      keepMounted: true // Better open performance on mobile.
                    }}
                >
                  {list}
                </Drawer>
              </Hidden>
            </Hidden>
          </Toolbar>
        </AppBar>
    )
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.token
  }
}

PagesHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger'])
}

export default connect(mapStateToProps, { logout })(withStyles(pagesHeaderStyle)(PagesHeader))



// WEBPACK FOOTER //
// ./src/components/Header/PagesHeader.jsx